export default {
  state: {

    modalCompletarDerivacion:{
      isVisible: false,
      id: null,
      isInformeTecnicoEnabled: false, // Nuevo estado
      dataForm: null
    },

    modalCrearInterconsultas:{
      isVisible: false,
      id: null,
      dataAtencion:null,
    },

    interconsultasFilters:{
      search:null,
      establecimiento:null
    }
  },

  mutations: {

    setInterconstultasFilters(state, newData){
      state.interconsultasFilters = { ...state.interconsultasFilters, ...newData }
    },

    setModalCompletarDerivacion(state, newData){
      state.modalCompletarDerivacion = { ...state.modalCompletarDerivacion, ...newData }
    },

    setDerivacionesDataForm(state, newData){
      state.modalCompletarDerivacion.dataForm = { ...state.modalCompletarDerivacion.dataForm, ...newData }
    },
    
    setModalCrearInterconsultas(state, newData) {
      state.modalCrearInterconsultas = { ...state.modalCrearInterconsultas, ...newData }
    },

  },

};